import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { LibModule } from '@ui-components/lib.module';
import { AccountModule } from './account/account.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AssessmentsModule } from './assessments/assements.module';
import { B2cPaymentModule } from './b2c-payment/b2c-payment.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { InviteModule } from './invite/invite.module';
import { LibManagementGroupModalModule } from '@ui-components/management-group-modal';
import { ProfileModule } from './profile/profile.module';

import { SessionAuthInterceptor } from '@ui-components/services';
import { OrgIdInterceptor } from './services/org-id.interceptor';

const http_interceptor_providers = [
  { provide: HTTP_INTERCEPTORS, useClass: OrgIdInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: SessionAuthInterceptor, multi: true },
];

@NgModule({
  declarations: [AppComponent],
  imports: [
    AccountModule,
    AppRoutingModule,
    AssessmentsModule,
    BrowserModule,
    BrowserAnimationsModule,
    B2cPaymentModule,
    DashboardModule,
    HttpClientModule,
    LibManagementGroupModalModule,
    InviteModule,
    ProfileModule,
    LibModule
  ],
  providers: [...http_interceptor_providers],
  bootstrap: [AppComponent]
})
export class AppModule { }
